module.exports = __webpack_public_path__ + "96995abc78f527ce66154739d5f1893c.svg";